import { combineReducers } from 'redux';

import identifiers from './identifiers';


export default combineReducers({
  data: identifiers,
});
